import React, { Fragment } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import moment from 'moment';

import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbDownAlt from '@material-ui/icons/ThumbDownAlt';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbUpAlt from '@material-ui/icons/ThumbUpAlt';
import DirectionsRun from '@material-ui/icons/DirectionsRun';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';

import {
    Select,
    InputLabel,
    MenuItem,
    FormControl,
    Card,
    CardHeader,
    CardContent,
    Typography,
    makeStyles,
    Icon,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    colors
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: '100%',
        maxHeight: '25vh',
    },
    list: {
        minWidth: 550,
        maxHeight: '25vh',
    },
    icon: {
        height: 40,
        width: 40
    },
    abs: {
        maxHeight: '35vh',
        minWidth: '50vh',
        overflow: 'auto'
    },
    avatar2: {
        height: 52,
        width: 52
    },
    avatar: {
        height: 32,
        width: 32,
        backgroundColor: colors.blue[400]
    }
}));

const Treatment = ({ item, open, closeEdition, updateValues, dependencies }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Tratamento de Alarme
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        mt={2}
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape(
                                    {
                                        action: Yup.string().max(100).required('Escolha da ação é o obrigatória'),
                                        detail: Yup.string().max(100).required('Justificativa / Comentário a respeito da ação escolhida é obrigatória')
                                    }
                                )
                            }

                            onSubmit={(values, formik) => {
                                updateValues(values);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (

                                <form onSubmit={handleSubmit}>

                                    <Grid container
                                        spacing={2}
                                        className={classes.baroperation}
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="flex-start"
                                    >
                                        <Grid item
                                            sm={6}
                                            xs={12}>

                                            <Card>
                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <NotificationsActiveIcon /></Avatar>
                                                    }
                                                    title={
                                                        <Typography
                                                            component="span"
                                                            variant="h5"
                                                            color="textPrimary">
                                                            <b>{values.alarm.description}</b>
                                                        </Typography>
                                                    }
                                                />

                                                <Divider></Divider>

                                                <CardContent>
                                                    <Box
                                                        alignItems="center"
                                                        display="flex"
                                                        flexDirection="column">
                                                        <Avatar className={classes.avatar2} style={{ backgroundColor: values.status.color }} >
                                                            <Icon className={classes.icon} component={values.status.icon} ></Icon>
                                                        </Avatar>
                                                        <Typography
                                                            style={{ color: values.status.color }}
                                                            variant="h5">
                                                            ( Status Atual é {`${values.status.name}`} )
                                                        </Typography>
                                                        <Typography
                                                            className={classes.dateText}
                                                            color="secondary"
                                                            variant="h4">
                                                            <b>Evento:</b> {moment(values.alarm.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                                                        </Typography>
                                                        <Typography
                                                            color="primary"
                                                            variant="h4">
                                                            <b>Equipamento:</b> {`${values.equipment.name}`}
                                                        </Typography>
                                                        <Typography
                                                            color="textSecondary"
                                                            variant="h5">
                                                            {`${values.equipment.description}`}
                                                        </Typography>
                                                        <Typography
                                                            color="body1"
                                                            variant="h5">
                                                            {`${values.location.plan}`}
                                                        </Typography>
                                                        <Typography
                                                            color="textSecondary"
                                                            variant="h5">
                                                            {`${values.location.name}`}
                                                        </Typography>
                                                        <Typography
                                                            color="textSecondary"
                                                            variant="h5">
                                                            {`${values.location.address} - ${values.location.neighborhood} - ${values.location.city}`}
                                                        </Typography>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                            <Box mt={2} ></Box>
                                            <Card>

                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <ThumbDownAlt /></Avatar>
                                                    }
                                                    title={
                                                        <Typography
                                                            component="span"
                                                            variant="h5"
                                                            color="textPrimary">
                                                            <b>{values.alarm.detail}</b>
                                                        </Typography>
                                                    }
                                                />

                                                <Divider></Divider>
                                                <CardContent square="true" className={classes.abs} >

                                                    <List dense className={classes.list}>

                                                        {values.alarm.fails.map((fail, index) => {
                                                            return (
                                                                <ListItem key={index} button>
                                                                    <ListItemAvatar>
                                                                        <Icon component={ThumbDown} style={{ color: colors.red[600] }}  ></Icon>
                                                                    </ListItemAvatar>
                                                                    <ListItemText id={index}
                                                                        primary={
                                                                            <Fragment>
                                                                                <Typography
                                                                                    component="span"
                                                                                    variant="body2"
                                                                                    color="textPrimary">
                                                                                    <b>Falha ocorrida:</b> {fail.detail}
                                                                                </Typography>
                                                                            </Fragment>}
                                                                        secondary={
                                                                            <Fragment>
                                                                                <Typography
                                                                                    component="span"
                                                                                    variant="body2"
                                                                                    color="textPrimary">
                                                                                    <b>Problema detectado:</b> {fail.description}
                                                                                </Typography>
                                                                                <br></br>
                                                                                <Typography
                                                                                    component="span"
                                                                                    variant="body2"
                                                                                    color="textPrimary">
                                                                                    <b>Condição:</b> ( {fail.field.name} = {fail.value}  {fail.field.sufix} )
                                                                                </Typography>
                                                                            </Fragment>
                                                                        }>
                                                                    </ListItemText>
                                                                </ListItem>
                                                            );
                                                        })}
                                                    </List>

                                                </CardContent>
                                            </Card>

                                        </Grid>

                                        <Grid item
                                            sm={6}
                                            xs={12}>

                                            <Card>
                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <ThumbUpAlt /></Avatar>
                                                    }
                                                    title={
                                                        <Typography
                                                            component="span"
                                                            variant="h5"
                                                            color="textPrimary">
                                                            <b>Ações</b>
                                                        </Typography>
                                                    }
                                                />

                                                <Divider></Divider>

                                                <CardContent square="true" className={classes.abs} >

                                                    {(dependencies.treatments && dependencies.treatments.length > 0) ? (

                                                        <List dense className={classes.list} >

                                                            {dependencies.treatments.map((treatment, index) => {
                                                                return (
                                                                    <ListItem key={index} button>
                                                                        <ListItemAvatar>
                                                                            <Icon component={ThumbUp} style={{ color: colors.blue[400] }}  ></Icon>
                                                                        </ListItemAvatar>
                                                                        <ListItemText id={index}
                                                                            primary={
                                                                                <Fragment>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="h6"
                                                                                        color="textPrimary">
                                                                                        <b>Data:</b> {moment(treatment.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                                                                                    </Typography>
                                                                                </Fragment>}
                                                                            secondary={
                                                                                <Fragment>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        color="textPrimary">
                                                                                        <b>Registro:</b> {treatment.detail}
                                                                                    </Typography>
                                                                                    <br></br>
                                                                                    <Typography
                                                                                        component="span"
                                                                                        variant="body2"
                                                                                        color="textPrimary">
                                                                                        <b>Usuário:</b> {(treatment.user) ? (treatment.user.firstname + ` ` + treatment.user.lastname) : ('Processo automático')}
                                                                                    </Typography>
                                                                                </Fragment>
                                                                            }>
                                                                        </ListItemText>
                                                                    </ListItem>
                                                                );
                                                            })}
                                                        </List>

                                                    ) : (
                                                        <Box className={classes.root}>
                                                            <Typography
                                                                component="span"
                                                                variant="body2"
                                                                color="textPrimary">
                                                                Nenhum ação registrada
                                                            </Typography>
                                                        </Box>

                                                    )}

                                                </CardContent>
                                            </Card>

                                            <Box mt={2} ></Box>

                                            <Card>
                                                <CardHeader variant="h6"
                                                    avatar={
                                                        <Avatar className={classes.avatar}>
                                                            <DirectionsRun /></Avatar>
                                                    }

                                                    title={
                                                        <Typography
                                                            component="span"
                                                            variant="h5"
                                                            color="textPrimary">
                                                            <b>Executar Ação</b>
                                                        </Typography>
                                                    }
                                                />

                                                <Divider></Divider>

                                                <CardContent square="true">

                                                    <Grid container
                                                        direction="row"
                                                        justify="flex-start"
                                                        alignItems="flex-start"
                                                        spacing={1}
                                                    >
                                                        <Grid
                                                            item
                                                            md={12}
                                                            xs={12}
                                                        >
                                                            <FormControl variant="outlined" fullWidth>
                                                                <InputLabel shrink htmlFor="action" required >Ação a ser executada</InputLabel>
                                                                <Select notched
                                                                    error={Boolean(touched.action && errors.action)}
                                                                    fullWidth={true}
                                                                    helperText={touched.action && errors.action}
                                                                    value={values.action}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    label="Ação a ser executada *"
                                                                    variant="outlined"
                                                                    inputProps={{
                                                                        name: 'action',
                                                                        id: 'action',
                                                                    }}
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>Selecione uma das opções abaixo</em>
                                                                    </MenuItem>
                                                                    {dependencies.actions.map((action) => (
                                                                        <MenuItem key={action.id} value={action.id}>{action.name}</MenuItem>
                                                                    ))}

                                                                </Select>
                                                            </FormControl>
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            xs={12}
                                                        >
                                                        </Grid>


                                                        <Grid
                                                            item
                                                            md={12}
                                                            xs={12}
                                                        >
                                                            <TextField
                                                                error={Boolean(touched.detail && errors.detail)}
                                                                fullWidth
                                                                helperText="Coloque aqui comentário ou justificativa a respeito da ação escolhida (100 caracteres)."
                                                                label="Justificativa / Comentário a respeito da ação escolhida *"
                                                                rows={2}
                                                                size={10}
                                                                multiline
                                                                margin="normal"
                                                                name="detail"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                value={values.detail}
                                                                variant="outlined"
                                                                InputLabelProps={{ shrink: true }}
                                                            />
                                                        </Grid>

                                                        <Grid
                                                            item
                                                            md={6}
                                                            xs={12}
                                                        >
                                                            <Grid container
                                                                direction="row"
                                                                justify="flex-end"
                                                                alignItems="flex-end"
                                                                spacing={1}  >
                                                                <TextField
                                                                    error={Boolean(touched.occurrence && errors.occurrence)}
                                                                    fullWidth
                                                                    required={(values.action == 8 || values.action == 10)}
                                                                    disabled={values.action != 8 && values.action != 10}
                                                                    helperText={touched.occurrence && errors.occurrence}
                                                                    label="Número da Ocorrência Associada"
                                                                    margin="normal"
                                                                    name="occurrence"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    value={values.occurrence}
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                />

                                                            </Grid>
                                                        </Grid>
                                                    </Grid>


                                                </CardContent>
                                            </Card>


                                        </Grid>

                                    </Grid>

                                    <Box my={1}></Box>

                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="center"
                                            spacing={1}  >
                                            <Grid item>

                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained"
                                                >
                                                    Executar
                                                </Button>

                                            </Grid>

                                            <Grid item >

                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeEdition() }}>
                                                    Fechar
                                                </Button>

                                            </Grid>
                                        </Grid>
                                    </Box>
                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog >

        </Fragment >
    );
};

export default Treatment;